import React, { use, useEffect, useState } from 'react';
import FilterSearchResults from '../../components/FilterSearchResults';
import SearchInput from '../../components/SearchInput';
import { useDispatch, useSelector } from "react-redux";
import { getSearchResults, getProducts, resetProductList, resetSearchPage, searchLoading,getSuggestion,resetSuggestion } from "../../containers/supportSearch/supportSearchSlice";
// import { getProducts,resetProductList } from "../../containers/searchLandingSlice";
import { useSearchParams } from 'react-router-dom';
import RenderSearchResults from '../../components/RenderSearchResults';
import { getCurrentLocal } from '../../utils';
import { useTranslation } from 'react-i18next';
import { resetFacet } from '../../containers/searchLandingSlice';
const SearchSupport = () => {
  const dispatch = useDispatch();
  const searchResultsArray = useSelector((state) => state?.supportSearch?.search?.searchResults?.grouped_docs);
  const productListArray = useSelector((state) => state?.supportSearch?.productCarousel?.products?.grouped_docs);
  const [facetResults, setFacetResults] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(1);
  const facetName = "Categories";
  let ignore = false;
  const [productList, setProductList] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [listingHeader, setListingHeader] = useState('');
  const isListLoading = useSelector((state) => state?.supportSearch?.productCarousel?.loading);
  const isMobile = window.innerWidth < 1024;

  useEffect(() => {

    if (!ignore) {
      dispatch(resetSearchPage())
      const q = searchParams.get('q') ? searchParams.get('q') : '*';
      const productListQuery = getProductListQUery(q);
      dispatch(getProducts(productListQuery));
      const searchInput = searchParams.get('q') ? searchParams.get('q') : '';
      if (searchInput.length > 1) {
        const { finalSearchListQuery } = getSearchListingQuery(searchInput);
        // const { facetSearchQuery } = getFacetQuery({ query: searchInput, docType: null });
        dispatch(getSearchResults(finalSearchListQuery));
        // dispatch(getFacetResults(facetSearchQuery));
      }
      return () => {
        ignore = true;
      };
    }
  }, []);

  useEffect(() => {
      if(productListArray){
        let tempKey = Object.keys(productListArray);
        setProductList(productListArray[tempKey]);
      }
    
  }, [productListArray]);

  useEffect(()=>{
    console.log(productListArray,'productListArray')
  },[productListArray])
  useEffect(() => {
    if (searchResultsArray) {
      const tempFacets = [];
      const tempKeys = Object.keys(searchResultsArray);
      tempKeys.forEach(element => {
        const objToPush = {
          selected: false,
          docType: element,
        };
        tempFacets.push(objToPush);
      });
      setFacetResults(tempFacets);
    }
  }, [searchResultsArray]);

  const getSearchListingQuery = (searchQuery) => {
    const paginationCount = 5;
    setCurrentPage(searchParams.get('p') ? searchParams.get('p') : 1);
    let groupBy = "&groupBy=grpDocumentType";
    let groupLimit = "&groupLimit=10";
    let documentType = "&documentType=";
    let documentTypeParams = "Support%20Products,Software%20Downloads,Knowledge%20Base,Community,documents";
    let variableParams = "&locale=" + getCurrentLocal().toLowerCase() + groupBy + groupLimit + documentType + documentTypeParams + "&from=" + ((currentPage - 1) * paginationCount) + "&rows=" + paginationCount;
    let finalSearchListQuery = "?q=" + searchQuery + variableParams;
    return { finalSearchListQuery };
  }



  const getProductListQUery = (searchQuery) => {
    const documentType = "&documentType=";
    const documentTypeParams = "Support%20Products";
    let variableParams = "&locale=" + getCurrentLocal().toLowerCase() + "&rows=5";
    let groupDocumentType = "&groupBy=grpDocumentType";
    let finalProductQuery = "?q=" + searchQuery + variableParams + groupDocumentType + documentType + documentTypeParams;
    return finalProductQuery;
  }

  const filterSelectedOptions = (filterSelectedOption) => {
    if (searchResultsArray) {
      let finalSearchResults = {
        docs: [],
        total: 0
      };
      if (filterSelectedOption.length > 1) {
        filterSelectedOption.forEach(option => {
          if (searchResultsArray[option]) {
            finalSearchResults.docs = finalSearchResults.docs.concat(searchResultsArray[option]);
          }
        });
        finalSearchResults.total = finalSearchResults.docs.length;
      } else {
        finalSearchResults.docs = searchResultsArray[filterSelectedOption[0]];
        finalSearchResults.total = searchResultsArray[filterSelectedOption[0]]?.length;
      }
      setSearchResults(finalSearchResults);
      setListingHeader(filterSelectedOption[0]);
    }
  };

  const handleSearchQueryChange = (newSearchQuery) => {
    if (newSearchQuery.length > 0) {
      setSearchParams({ q: newSearchQuery });
      const { finalSearchListQuery } = getSearchListingQuery(newSearchQuery);
      const productListQuery = getProductListQUery(newSearchQuery);

      dispatch(getSearchResults(finalSearchListQuery));
      dispatch(getProducts(productListQuery));

      const localFacets = searchResults?.facet_fields?.grpDocumentType;
      setFacetResults(localFacets);

    }
    else {
      if (!newSearchQuery || newSearchQuery.length === 0) {
        //   // reset search page
        dispatch(resetSearchPage());
        setFacetResults([]);
        setSearchResults([]);
        const productListQuery = getProductListQUery("*");
         dispatch(getProducts(productListQuery));
        // Clear the search parameters
        setSearchParams();
      }
    }
  };
  const handlePageChange = (page) => {
    const q = searchParams.get('q');
    setSearchParams({ q: q, p: page });
    setCurrentPage(page);
    const { finalSearchListQuery } = getSearchListingQuery(q);
    dispatch(getSearchResults(finalSearchListQuery));
  };

  const clearSuggestion = () => {
    dispatch(resetSuggestion())
  }
  const getCustomerChannel = () => {
    // Function to get cookie value by name
    const getCookie = (name) => {
      const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return match ? match[2] : null;
    };
 
    // Check if channel is available in cookies
    const channelCookie = getCookie("Channel");
    return channelCookie || "B2C"; // Return the cookie value if found, else return "B2C"
  };

  const getSuggestionData = async (searchText) => {
    // let payload=sanitizeInput(searchText)
      let sentence = searchText.trim();
      let words = sentence.split(' ');
      let modifiedWords = words.map(word => {
        if (word.includes('-')) {
          return `"${word}"`;
        }
        return word;
      });
    let payload = modifiedWords.join(' ');
    let q = '?q=' + payload 
    let channel="&channel="+getCustomerChannel()
    let variableParams = "&locale=" + getCurrentLocal().toLowerCase() + "&groupBy=grpDocumentType&groupLimit=5&rows=500&documentType=Support%20Products,Software%20Downloads,Knowledge%20Base,Community,documents"+channel;
    dispatch(getSuggestion(q + variableParams))

  }

  return (
    <section className="sd-relative">
      <div className="sd-container">
        <div className="sd-grid lg:sd-grid-cols-16 sd-grid-cols-8 sd-gap-4">
          <div className="lg:sd-h-screen-minus-48 sd-flex sd-flex-col lg:sd-col-span-4 sd-col-span-8 lg:sd-border-r lg:sd--ml-4 lg:sd-sticky lg:sd-top-[48px] lg:sd-z-10 ">
            <div className="lg:sd-py-[2rem] sd-pt-[2rem] sd-pb-[1rem]  lg:sd-pl-4 sd-sdList lg:sd-border-b lg:sd-col-span-8 sd-col-span-4">
              {!isMobile ? (
                <div className="sd-uppercase sd-titleText  sd-font-nb sd-text-[13px]">{t('backToSupport')}</div>
              ) : (
                <a href="#" className="sd-uppercase sd-titleText sd-font-nb sd-text-[13px]">{'Support / Search'}
                </a>
              )}
            </div>
            <FilterSearchResults searchResults={facetResults} onFilterChange={filterSelectedOptions} facetName={facetName} isAll={0} />
          </div>
          <div className="sd-gap-4 sd-col-span-8 lg:sd-col-span-12 lg:sd-col-start-5  lg:sd-pt-9 sd-mb-[88px] lg:sd-mb-[136px]">
            <SearchInput onSearchQueryChange={handleSearchQueryChange} getSuggestionData={getSuggestionData}  clearSuggestion={clearSuggestion}  page={'search_support'}/>
            {<RenderSearchResults searchResults={searchResults} onPageChange={handlePageChange} productList={productList} listingHeader={listingHeader}  />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchSupport;
